import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { APPLICATION_TYPES } from 'src/app/model/constants/application-types';
import { IUniversity } from 'src/app/model/degree/iuniversity';
import { AnsokanFormGroupService } from 'src/app/service/ansokan-form-group/ansokan-form-group.service';
import { DegreeService } from 'src/app/service/degree/degree.service';
import { PAGE_NAMES } from '../../../service/ansokan-form-builder/application-names';
import { EXAMINA_FORM_DEF } from '../../../service/ansokan-form-builder/form-definitions';
import { PaymentCalculator } from '../../payment-calculator';

@Component({
    selector: 'app-degree',
    styleUrls: ['./degree.component.scss'],
    templateUrl: './degree.component.html',
    standalone: false
})
export class DegreeComponent implements OnInit {

  public universities$: Observable<IUniversity[]>;
  public first: UntypedFormGroup;
  public second: UntypedFormGroup;
  public hasSecond: UntypedFormControl;
  private group: UntypedFormGroup;
  private calculator: PaymentCalculator;

  constructor(
    private formGroupService: AnsokanFormGroupService,
    private degreeService: DegreeService,
    private fb: UntypedFormBuilder,
  ) {
    this.calculator = new PaymentCalculator(APPLICATION_TYPES.NEW_SWEDISH);
  }

  public get payment(): number {
    return this.group ? this.calculator.calulate(this.group.value) : null;
  }

  public ngOnInit() {
    // Get degree form group.
    this.group = this.formGroupService.get(PAGE_NAMES.DEGREE.KEY) as UntypedFormGroup;
    // Get examina form groups.
    this.first = this.group.get(PAGE_NAMES.DEGREE.FIRST.KEY) as UntypedFormGroup;
    this.second = this.group.get(PAGE_NAMES.DEGREE.SECOND_OPTIONAL.KEY) as UntypedFormGroup;
    // Get universities.
    this.universities$ = this.degreeService.getUniversities()
      .pipe(
        map((result: IUniversity[]) => {
          result.push({ code: 'OTHER', name: 'Annat lärosäte' });
          return result;
        }),
        shareReplay(1),
      );
    // Create selector form control.
    this.hasSecond = new UntypedFormControl(this.second !== null);
    this.hasSecond.valueChanges.subscribe((value: boolean) => {
      this.second = value ? this.fb.group(EXAMINA_FORM_DEF) : null;
      this.group.setControl(PAGE_NAMES.DEGREE.SECOND_OPTIONAL.KEY, this.second);
    });
  }
}
